// extracted by mini-css-extract-plugin
export default {"sideBar":"index_sideBar_slC01","h2wrapper":"index_h2wrapper_XbBTf"};